export default __webpack_public_path__ + "thesis-fveliz.pdf";